// extracted by mini-css-extract-plugin
export default {"surgeriesContainer":"Surgeries_surgeriesContainer__j9EDA"};